/**
 * User Profile translations
 * User profile component UI text
 */

import { LANGUAGES } from '../config';

export const userProfileTranslations = {
  [LANGUAGES.EN]: {
    name: 'Name',
    email: 'Email',
    role: 'Role',
    manager: 'Manager',
    none: 'None',
    userInformation: 'User Information',
    teamMembers: 'Team Members',
    permissions: 'Permissions',
    logOut: 'Log Out',
    tabProfile: 'Profile',
    tabTeam: 'Team',
    tabSecurity: 'Security',
    teamStructure: 'Team Structure',
    yourManager: 'Your Manager',
    yourTeamMembers: 'Your Team Members',
    noTeamMembers: 'No team members',
    teamMembersWillAppear: 'Team members will appear here when assigned.',
    roleAdmin: 'Administrator',
    roleManager: 'Manager',
    roleUser: 'User',
    roleUnknown: 'Unknown Role',
    permViewOwnAnalyses: 'View own analyses',
    permCreateCVAnalysis: 'Create CV analysis',
    permCreateJobAnalysis: 'Create job analysis',
    permViewAllAnalyses: 'View all analyses',
    permCreateCompanyResearch: 'Create company research',
    permViewAnalytics: 'View analytics',
    permManageUsers: 'Manage users',
    permManageRoles: 'Manage roles',
    permSystemConfig: 'System configuration',
    permViewPublicReports: 'View public reports'
  },
  [LANGUAGES.FR]: {
    name: 'Nom',
    email: 'Email',
    role: 'Role',
    manager: 'Gestionnaire',
    none: 'Aucun',
    userInformation: 'Informations utilisateur',
    teamMembers: 'Membres de l equipe',
    permissions: 'Permissions',
    logOut: 'Deconnexion',
    tabProfile: 'Profil',
    tabTeam: 'Equipe',
    tabSecurity: 'Securite',
    teamStructure: 'Structure de l equipe',
    yourManager: 'Votre gestionnaire',
    yourTeamMembers: 'Membres de votre equipe',
    noTeamMembers: 'Aucun membre d equipe',
    teamMembersWillAppear: 'Les membres de l equipe apparaitront ici lorsqu ils seront assignes.',
    roleAdmin: 'Administrateur',
    roleManager: 'Gestionnaire',
    roleUser: 'Utilisateur',
    roleUnknown: 'Role inconnu',
    permViewOwnAnalyses: 'Voir ses propres analyses',
    permCreateCVAnalysis: 'Creer une analyse de CV',
    permCreateJobAnalysis: 'Creer une analyse d emploi',
    permViewAllAnalyses: 'Voir toutes les analyses',
    permCreateCompanyResearch: 'Creer une recherche d entreprise',
    permViewAnalytics: 'Voir les analyses',
    permManageUsers: 'Gerer les utilisateurs',
    permManageRoles: 'Gerer les roles',
    permSystemConfig: 'Configuration du systeme',
    permViewPublicReports: 'Voir les rapports publics'
  }
};
